import Model from '@ember-data/model';

export default class LegacyMembershipPurchaseModel extends Model {
  // This is just needed for polymorphic relationship (source) to work
}
